const env = {
  apiUrl: 'https://localhost:5001/api/ceaportal/',
  language: 'pt'
};

export default env;
